import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";

/**
 * Enum que representam os campos para a tabela de Mux/Demux.
 *
 * Os valores da enum seguem o formato esperado para o campo da tabela, camelCase,
 * diferente das chaves da enum que usam TitleCase.
 */
export enum MuxField {
    Name                  = "name",
    SerialNumber          = "serialNumber",
    Model                 = "model",
    AssociatedDevices     = "associatedDevices"
}

/**
 * Representa uma ação que pode ser aplicada em um conjunto de linhas de uma grid/tabela (ou outro conjunto de objetos).
 *
 * @interface MuxActionModel
 * @description
 *   • "id" – identificador único da ação. É útil para registro / controle de UI.
 *   • "translateKey" – chave de tradução (ex.: "delete.action") que será usada pelo sistema de internacionalização.
 *   • "action" – função que executa a ação propriamente dita.
 */
export interface MuxActionModel {
    id: string;
    translateKey: string;
    action(selectRows?: Array<Object>): any;
}

/* Representa os dados de um equipamento DWDM */
export interface DwdmDevice {
    resourceId: number;
    name: string;
}

/** Representa o modelo a ser utilizado na modal de Mux/Demux */
export interface MuxDemuxModal {
    muxDemuxInfo: MuxDemux;
}

/**Representa dados dos modelos para MUX/DEMUX */
export interface MuxModel {
    name: string;
    channelAmount: number;
}

/** Representa o modelo para criação de Mux/Demux da aba de informações */
export class MuxDemuxInfoModel extends NmsWizardStepModel {
    resourceId?: number;
    name: string;
    serialNumber: string;
    model: string;
    channelAmount: number;
}

/** Representa o modelo para a aba de devices do Mux/Demux */
export class MuxDemuxDevicesModel extends NmsWizardStepModel {
    devices: DwdmDevice[] = [];
    description: string = "";
}

/** Representa o modelo a ser exibido na listagem de Mux/Demux */
export class MuxDemuxResponse {
    resourceId: number;
    name: string;
    serialNumber: string;
    model: string;
    description: string;
    associatedDevices: string;
}

/* Representa os dados de Mux/Demux DWDM */
export class MuxDemux {
    resourceId: number;
    name: string;
    serialNumber: string;
    model: string;
    description: string;
    devices: DwdmDevice[];

    constructor(resourceId: number = 0,
                name: string = "",
                serialNumber: string = "",
                model: string = "",
                description: string = "",
                devices: DwdmDevice[] = []) {
        this.resourceId = resourceId;
        this.name = name;
        this.serialNumber = serialNumber;
        this.model = model;
        this.description = description;
        this.devices = devices;
    }
}

/** Representa a resposta enviada pelo back durante a remoção dos muxes
 *  onde a lista de true representa os muxes removidos com sucesso e
 *  a lista de false representa os muxes não encontrados durante o processo
 *  de remoção.
 */
export interface MuxRemoveResponse {
    false: Array<number>;
    true: Array<number>;
}
